import React, { useEffect, useState } from "react";
import "./style.css";
import BackIcon from "../../Assets/Icons/BackIcon";
import NavbarCustom from "../../Components/NavbarCustom";
import { useLocation } from "react-router-dom";
import { useBuyPackages } from "../../APIContext/BuyPackagesContext";
import BackBtn from "../../Components/BackBtn/BackBtn";
import Swal from "sweetalert2";

export const PackageDetails = () => {
  const {
    packageDetails,
    fetchPackagesDetailsByID,
    proceedToCheckout,
    fetchPackagesDetailsByIDs,
    packageDetailsByIDs,
  } = useBuyPackages();
  const location = useLocation();
  const [totalAmount, setTotalAmount] = useState(null);

  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const childID = queryParams.get("childId");
  const parsedIds =
    id && id.includes(",")
      ? id.split(",").map((num) => parseInt(num.trim()))
      : id
        ? [parseInt(id)]
        : [];

  const idsPayload = { ids: parsedIds };

  // const handleBuyNow = async () => {
  //     try {
  //         if (packageDetails?.id) {
  //             const data = { package_id: packageDetails.id };
  //             if (childID) {
  //                 data.player_id = parseInt(childID);
  //             }
  //             await proceedToCheckout(data);

  //         } else {
  //             console.warn("Package ID not found");
  //         }
  //     } catch (error) {
  //         console.error("Error during Buy Now:", error);
  //     }
  // };

  const handleBuyNow = async () => {
    try {
      if (packageDetailsByIDs && packageDetailsByIDs.length > 0) {
        // Build the array of packages dynamically
        const packagesPayload = packageDetailsByIDs.map((pkg) => {
          const pkgData = { package_id: pkg.id };

          // If it's an unlimited package (for example, check a flag or name), add player_id
          if (pkg.is_unlimited || pkg.package_type === "unlimited") {
            if (childID) pkgData.player_id = parseInt(childID);
          }

          return pkgData;
        });

        const data = { packages: packagesPayload };

        // console.log("Payload sent to checkout:", data);

        await proceedToCheckout(data);
      } else {
        Swal.fire({
          icon: "warning",
          title: "No Packages Found",
          text: "No package details found to process.",
          confirmButtonColor: "#B79527", // orange / gold
          cancelButtonColor: "#1C1C1C",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error during purchase process. Please try again.",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
    }
  };

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          await fetchPackagesDetailsByIDs(idsPayload);
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Error fetching package details. Please try again.",
            confirmButtonColor: "#B79527", // orange / gold
            cancelButtonColor: "#1C1C1C",
          });
        }
      })();
    }
  }, [location.search]);

  useEffect(() => {
    if (packageDetailsByIDs && packageDetailsByIDs.length > 0) {
      const total = packageDetailsByIDs.reduce(
        (sum, pkg) => sum + (Number(pkg.price) || 0),
        0,
      );
      setTotalAmount(total);
    }
  }, [packageDetailsByIDs]);

  return (
    <>
      <NavbarCustom />
      <div className="buy-packages-details-sports-container">
        <div className="buy-packages-header">
          <BackBtn />
          <div className="buy-packages-header-content">
            <h1 className="buy-packages-heading">Purchase Your Packages</h1>
          </div>
        </div>

        <div className="buy-packages-details-preferred-sports">
          <div className="package-details-container">
            {packageDetailsByIDs && packageDetailsByIDs.length > 0 ? (
              <>
                <p>Fetched package details:</p>
                {packageDetailsByIDs?.map((pkg, index) => (
                  <div className="single-package-section" key={pkg?.id}>
                    <div className="header-section">
                      <p>
                        <span className="black-text-clip">
                          Package Details {index + 1}
                        </span>
                      </p>
                      <p></p>
                    </div>
                    <div className="footer-section">
                      <p>
                        <span className="black-text-clip">Package Name:</span>
                      </p>
                      <p>
                        <span className="black-text-clip">{pkg?.name}</span>
                      </p>
                    </div>
                    <div className="footer-section">
                      <p>
                        <span className="black-text-clip">Sport:</span>
                      </p>
                      <p>
                        <span className="black-text-clip">
                          {pkg?.sports_detail?.name}
                        </span>
                      </p>
                    </div>
                    <div className="footer-section">
                      <p>
                        <span className="black-text-clip">Company:</span>
                      </p>
                      <p>
                        <span className="black-text-clip">
                          {pkg?.company_detail?.name}
                        </span>
                      </p>
                    </div>

                    {pkg?.one_on_one_sessions != null &&
                      pkg.one_on_one_sessions > 0 && (
                        <div className="footer-section">
                          <p>
                            <span className="black-text-clip">
                              One on One Session:
                            </span>
                          </p>
                          <p>
                            <span className="black-text-clip">
                              {pkg.one_on_one_sessions}
                            </span>
                          </p>
                        </div>
                      )}
                    {pkg?.group_sessions != null && pkg.group_sessions > 0 && (
                      <div className="footer-section">
                        <p>
                          <span className="black-text-clip">
                            Group Session:
                          </span>
                        </p>
                        <p>
                          <span className="black-text-clip">
                            {pkg.group_sessions}
                          </span>
                        </p>
                      </div>
                    )}
                    <div className="footer-section">
                      <p>
                        <span className="black-text-clip">Price:</span>
                      </p>
                      <p>
                        <span className="black-text-clip">${pkg?.price}</span>
                      </p>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              ""
            )}

            {/* dummy content for now */}

            <div className="single-package-subtotal-section">
              <div className="header-section">
                <p className="black-text-clip">Total Amount:</p>
                <p className="black-text-clip text-right">${totalAmount}</p>
              </div>
            </div>

            <button
              type="submit"
              className="p-submit-button"
              onClick={handleBuyNow}
            >
              Buy Now
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
